import React from "react";
import { Container } from "react-bootstrap";
import backarrow from "../../assets/svg/nav-prev.svg";
import { ReactComponent as UnAuthorizedIcon } from "../../assets/svg/unauthorized.svg";
import PoweredBy from "./poweredBy.jsx";
const UnAuthorized = () => {
  const accountUrl = process.env.REACT_APP_ACCOUNTS_URL;
  return (
    <Container fluid style={{ width: "100vw", minHeight: "100vh", padding: "0px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <div style={{ width: "600px", height: "455px", background: "#FFFFFF", borderRadius: "24px", padding: "48px", gap: "32px", textAlign: "center" }}>
        <UnAuthorizedIcon />
        <p className="mt-3 GTWalsheimTrial" style={{ fontSize: "28px", fontWeight: "700", color: "#212172C" }}>
          Unauthorized !!
        </p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <p className="GTWalsheimTrial" style={{ width: "359px", fontSize: "15px", fontWeight: "400", color: "#212172C" }}>
            You don’t have an access to this page. Please go back to home for access application.
          </p>
        </div>
        <button
          onClick={() => {
            window.location.href = accountUrl;
          }}
          style={{ backgroundColor: "#6929E2", color: "#FFFFFF", border: "none", borderRadius: "100px", fontWeight: "700", fontSize: "15px" }}
          className="px-4 py-2"
        >
          <img src={backarrow} alt="back" className="px-2" /> Back to home
        </button>
      </div>
      <div style={{ position: "absolute", bottom: "0", width: "100%" }}>
        <PoweredBy marginTop="20px" paddingBottom="20px" />
      </div>
    </Container>
  );
};

export default UnAuthorized;
